import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  async function fetchProfile(userId) {
  if (!userId) return;
  const { data } = await supabase
    .from('users')
    .select('*')
    .eq('id', userId)
    .maybeSingle();
  if (data) {
    data.branches = data.branch_name ? { name: data.branch_name } : null;
    setProfile(data);
  }
}

  useEffect(() => {
    async function initAuth() {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        await supabase.auth.refreshSession();
      }
      const currentUser = session?.user ?? null;
      setUser(currentUser);
      if (currentUser?.id) {
        await fetchProfile(currentUser.id);
      }
      setLoading(false);
    }

    initAuth();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      const currentUser = session?.user ?? null;
      setUser(currentUser);
      if (currentUser?.id) {
        fetchProfile(currentUser.id);
      } else {
        setProfile(null);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  async function signIn(email, password) {
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    return { error };
  }

  async function signOut() {
    await supabase.auth.signOut();
    setUser(null);
    setProfile(null);
  }

  const isAdmin = profile?.role === 'admin';
  const isExecutive = profile?.role === 'executive';
  const isManager = profile?.role === 'manager' || isAdmin;
  const isTeamMember = profile?.role === 'team_member';

// Convenience: can this user do field actions (tag-out, inspections)?
const canDoFieldWork = isTeamMember || isManager;

  return (
  <AuthContext.Provider value={{ 
    user, profile, loading, signIn, signOut, 
    isAdmin, isExecutive, isManager, isTeamMember, canDoFieldWork 
  }}>
    {children}
  </AuthContext.Provider>
);
}

export const useAuth = () => useContext(AuthContext);